import React from 'react'
import styled, { keyframes } from 'styled-components'
import { getBorderRadius } from '../../../utils/styleUtils'

/* CONSTANTS */
import { CLIENT_STYLINGS, size } from '../../../utils/constants'

const loadingFade = keyframes`
  0% { opacity: 0; }
  50% {opacity: 0.8; }
  100% { opacity: 0; }
`

export const SearchOuterWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  z-index: 999999999;
`

export const SearchBoxWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;

  @media (max-width: ${size.laptop}) {
    width: unset;
  }

  border: 1px solid ${props => (props.$isSearchFocused ? '#999999' : '#D9D9D9')};
  border-radius: ${props => getBorderRadius(props, 'sm')};
  border-bottom-left-radius: ${props =>
    props.$isSearchFocused ? '0' : getBorderRadius(props, 'sm')};
  border-bottom-right-radius: ${props =>
    props.$isSearchFocused ? '0' : getBorderRadius(props, 'sm')};
  border-bottom: ${props =>
    props.$isSearchFocused
      ? `none`
      : `1px solid ${props =>
          props.$isSearchFocused ? '#999999' : '#D9D9D9'}`};
`

export const SearchInputWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

export const SearchResultsItemIcon = styled.div`
  width: 30px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const SearchResultCategoryIcon = styled.div`
  width: 25px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`
export const SearchIconWrapper = styled.div`
  width: 30px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const SearchInput = styled.input`
  position: relative;
  width: calc(100% - 30px);
  height: 100%;
  border: none;
  border-radius: ${props => getBorderRadius(props, 'sm')};
  z-index: 1;

  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  padding: 10px;
  resize: none;
  font-size: 16px !important;

  &:focus {
    outline: none !important;
    border: none;
  }

  &:hover {
    cursor: pointer;
  }
`

export const SearchResultsWrapper = styled.div`
  position: absolute;
  top: ${props => props.$topPosition}px;
  width: ${props => props.width};
  display: flex;
  flex-direction: column;
  z-index: 2;
  background: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
  border-radius: ${props => getBorderRadius(props, 'sm')};
  overflow-y: scroll;
  max-height: 400px;
  padding-top: 10px;

  border: 1px solid ${props => (props.$isSearchFocused ? '#999999' : '#D9D9D9')};
  border-radius: ${props => getBorderRadius(props, 'sm')};
  border-top-left-radius: ${props =>
    props.$isSearchFocused ? '0' : getBorderRadius(props, 'sm')};
  border-top-right-radius: ${props =>
    props.$isSearchFocused ? '0' : getBorderRadius(props, 'sm')};
  border-top: ${props =>
    props.$isSearchFocused ? `none` : `1px solid #D9D9D9`};

  @media (max-width: ${size.laptop}) {
    max-height: 350px;
  }

  &::-webkit-scrollbar {
    display: block;
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #999999;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #999999;
  }
`

export const SearchResultsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const SearchResultsItem = styled.a`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 8px;
  padding-left: 10px;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  position: relative;

  &:hover {
    background-color: ${props => {
      const color = CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY
      // Convert hex to rgba with opacity
      if (color.startsWith('#')) {
        const r = parseInt(color.slice(1, 3), 16)
        const g = parseInt(color.slice(3, 5), 16)
        const b = parseInt(color.slice(5, 7), 16)
        return `rgba(${r}, ${g}, ${b}, 0.4)`
      }
      // If already rgba or rgb, try to extract and modify
      if (color.includes('rgba')) {
        return color.replace(/rgba?\(([^)]+)\)/, (match, values) => {
          const parts = values.split(',').map(v => v.trim())
          if (parts.length === 4) {
            return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, 0.4)`
          }
          return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, 0.4)`
        })
      }
      // Fallback: use opacity property on pseudo-element
      return color
    }};
    color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
    cursor: pointer;
  }
`

export const SearchResultCategoryTitleWrapper = styled.div`
  width: calc(100% - 25px);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`
export const SearchResultsItemTitleWrapper = styled.div`
  width: calc(100% - 30px);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
`

export const SearchResultsItemTitle = styled.h3`
  font-size: 16px;
  font-weight: 400;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  line-height: 20px;
  margin: 0;
`

export const SearchResultsItemSubtitle = styled.h3`
  font-size: 12px;
  font-weight: 400;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  line-height: 20px;
  margin: 0;
  padding-top: 2px;
`

export const SearchUnderline = styled.div`
  width: 90%;
  height: 2px;
  background-color: #999999;
  margin: 0 auto;
`

export const SearchResultsCategoryWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`

export const SearchResultCategoryContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 8px;
  padding-left: 10px;
  padding-top: 15px;
`

export const SearchResultCategoryTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
`

export const SearchPlaceHolder = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  align-self: flex-start;
  padding: 10px;
`
